<template>
  <div>
    <YsDataTable
      ref="ysTable"
      v-model="refresh"
      :page-size="searchPage.page_size"
      :list="searchList"
      :dep-option-map="options"
      :button-list="buttonList"
      :page-sizes="[10, 20, 30, 50, 100]"
      :columns="columns"
      :fetch-method="fetchMethod"
      :select-change="handleSelectChange"
      use-data-field
      page-size-alias="pagesize"
      max-height="680"
      @on-change="handleParamsChange"
      @on-page-change="handlePageChange"
    >
      <template #packageNo="{ row }">
        <div class="special-sale">
          <div>
            {{ row.package_no }}
          </div>
          <div>{{ row.packge_status_trans }}</div>
        </div>
      </template>
      <template #packageType="{ row }">
        <div class="special-sale">
          <div>
            {{ row.package_type_trans }}
          </div>
          <div>{{ row.spr_create_time }}</div>
          <div>{{ row.db_source_txt }}</div>
        </div>
      </template>
      <template #city_group_name="{ row }">
        <div class="special-sale">
          <div>{{ row.city_name }}</div>
          <div>{{ row.pgid_name }}</div>
          <div>{{ row.pg_member_name }}</div>
        </div>
      </template>

      <template #goodsImage="{ row }">
        <div
          style="height: 80px; width: 80px; margin: 0 auto; cursor: pointer"
          @click="handleViewImages(row.turn_over_buy_img_trans)"
        >
          <img
            :src="row.turn_over_buy_img_trans && row.turn_over_buy_img_trans[0]"
            style="max-width: 100%; max-height: 100%"
          />
        </div>
      </template>

      <template #corrPackageNo="{ row }">
        <div class="special-sale">
          <div>
            {{ row.corr_package_no }}
          </div>
          <div>{{ row.corr_package_status_trans }}</div>
        </div>
      </template>
      <template #storehouseRemark="{ row }">
        <div class="special-sale">
          <div>
            {{ row.storehouse_remark }}
          </div>
          <div
            v-if="
              row.storehouse_operation ===
              constantMap.storehouseOperationMap.returnedForRefund
            "
            style="height: 80px; width: 80px; margin: 0 auto; cursor: pointer"
            @click="handleViewImages(row.exit_goods_imgs)"
          >
            <img
              :src="row.exit_goods_imgs && row.exit_goods_imgs[0]"
              style="max-width: 100%; max-height: 100%"
            />
          </div>
        </div>
      </template>
      <template #created="{ row }">
        <div class="special-sale">
          <div>
            {{ row.create_admin_name }}
          </div>
          <div>{{ row.created_at }}</div>
        </div>
      </template>
      <template #submitBuy="{ row }">
        <div class="special-sale">
          <div>
            {{ row.submit_buy_admin_name }}
          </div>
          <div>{{ row.submit_buy_time_trans }}</div>
        </div>
      </template>
      <template #buyHandle="{ row }">
        <div class="special-sale">
          <div>
            {{ row.buy_handle_admin_name }}
          </div>
          <div>{{ row.buy_handle_buy_time_trans }}</div>
        </div>
      </template>
      <template #storehouseHandle="{ row }">
        <div class="special-sale">
          <div>
            {{ row.storehouse_handle_admin_name }}
          </div>
          <div>{{ row.storehouse_handle_time_trans }}</div>
        </div>
      </template>

      <template #actions="{ row }">
        <el-button type="text" @click="handleShowOperateLog(row)">
          查看日志
        </el-button>
      </template>

      <template #special_sale="{ row }">
        <div class="special-sale">
          {{ row.last_three_day_special_sale_num }}/{{
            row.last_three_day_special_sale_amount
          }}
        </div>
      </template>
      <template #special_allot="{ row }">
        <div class="special-sale">
          {{ row.last_three_day_special_allot_num }}/{{
            row.last_three_day_special_allot_amount
          }}/{{ row.last_three_day_special_rate }}
        </div>
      </template>
      <template #operate_admin_time="{ row }">
        <div class="special-sale">
          <div>{{ row.operator_admin_text }}</div>
          <div>{{ row.operator_datetime }}</div>
        </div>
      </template>
    </YsDataTable>
    <el-dialog title="操作日志" :visible.sync="logVisible">
      <YsDataTable
        ref="ysTable"
        v-model="refreshLog"
        :init-params="initParams"
        :columns="columnsLog"
        :fetch-method="fetchMethodLog"
        :select-change="handleSelectChange"
        use-data-field
        @on-change="handleParamsChange"
        @on-page-change="handlePageChange"
      ></YsDataTable>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { fetchSupplyBySearch } from "@/api/common.js";
import apiBaseURL from "@/utils/baseUrl.js";
import { getOptionsForList } from "@/openapi/erp/performanceReport.js";
import { postListStockStorehouseConfig } from "@/openapi/erp/stockStorehouse.js";
import {
  postListNoDataPackage,
  postPageNoDataPackageRecord,
} from "@/openapi/erp/noDataPackage.js";

const constantMap = Object.freeze({
  storehouseOperationMap: {
    transferredToPickup: "1", // 已移交点货
    transferredNoDataGoods: "2", // 已移交无数据商品
    returnedForRefund: "3", // 已返包退供
    withdrawn: "4", // 撤回
  },
  optionsStatus: [
    { label: "待仓库核实", value: 1 },
    { label: "待代采处理", value: 2 },
    { label: "待仓库处理", value: 3 },
    { label: "已处理", value: 4 },
  ],
  packageTypeOptions: [
    { label: "大货", value: 1 },
    { label: "前置仓", value: 3 },
    { label: "备货", value: 2 },
  ],
  packageStatusOptions: [
    { label: "待接收", value: 1 },
    { label: "待质检", value: 5 },
    { label: "已接收", value: 2 },
    { label: "已点货", value: 3 },
    { label: "已作废", value: 4 },
  ],
  noDataReasonOptions: [
    { label: "整包无法点货", value: 1 },
    { label: "部分无法点货", value: 2 },
    { label: "无法识别商家", value: 3 },
  ],
  buyVerifyOptions: [
    { label: "商家有欠货,移交点货", value: 1 },
    { label: "商家无欠货,打无数据商品", value: 2 },
    { label: "商家送错,返包退供", value: 3 },
  ],
  operationOptions: [
    { label: "已移交点货", value: 1 },
    { label: "已移交无数据商品", value: 2 },
    { label: "已返包退供", value: 3 },
    { label: "点货员已点货", value: 4 },
  ],
});

export default {
  name: "NotDataPackageList",
  data() {
    return {
      constantMap,
      list: [],
      refresh: false,
      searchParams: {},
      searchPage: {
        page_size: 10,
        page: 1,
      },
      options: {
        supply: [],
        city: [],
        big_market: [],
        pg_name: [], // 代采组
        pg_member: [], // 代采员
      },
      searchList: [
        {
          tag: "input",
          field: "package_no",
          label: "包裹号",
        },
        {
          tag: "input",
          field: "package_record_id",
          label: "无数据包裹ID",
        },
        {
          tag: "select",
          field: "no_data_status",
          label: "状态",
          options: constantMap.optionsStatus,
        },
        {
          tag: "select",
          field: "storehouse_id",
          label: "仓库",
          optionsField: "storeList",
          labelKey: "label",
          valueKey: "key",
        },
        {
          tag: "select",
          field: "package_type",
          label: "包裹类型",
          options: constantMap.packageTypeOptions,
        },
        {
          tag: "select",
          field: "packge_status",
          label: "包裹状态",
          options: constantMap.packageStatusOptions,
          props: {
            multiple: true,
          },
        },
        {
          tag: "select",
          field: "supply_id",
          label: "商家",
          optionsField: "supply",
          props: {
            filterable: true,
            remote: true,
            remoteMethod: this.fetchSupply,
          },
        },
        {
          tag: "select",
          field: "city_id",
          label: "城市",
          optionsField: "city",
          props: {
            multiple: true,
          },
        },
        {
          tag: "select",
          field: "pg_id",
          label: "代采组",
          optionsField: "pg_name",
        },
        {
          tag: "select",
          field: "pg_member_id",
          label: "代采员",
          optionsField: "pg_member",
        },
        {
          tag: "select",
          field: "no_data_reason",
          label: "无理由数据",
          options: constantMap.noDataReasonOptions,
        },
        {
          tag: "select",
          field: "buy_verify",
          label: "包裹处理方案（代采核实）",
          options: constantMap.buyVerifyOptions,
        },
        {
          tag: "select",
          field: "storehouse_operation",
          label: "仓库处理信息",
          options: constantMap.operationOptions,
        },
        {
          tag: "date",
          label: "创建时间",
          field: "create_time",
          props: {
            type: "daterange",
            placeholder: "请选择",
            valueFormat: "yyyy-MM-dd",
          },
          defaultValue: [
            dayjs().subtract(31, "day").format("YYYY-MM-DD"),
            dayjs().format("YYYY-MM-DD"),
          ],
          transform: (list) => {
            return {
              create_time: list
                ? list.map((date) => dayjs(date).format("YYYY-MM-DD"))
                : "",
            };
          },
        },
      ],
      buttonList: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: this.handleExportExcelList,
          },
        },
      ],
      fetchMethod: postListNoDataPackage,
      columns: [
        {
          label: "无数据包裹ID",
          prop: "id",
        },
        {
          label: "仓库",
          prop: "storehouse_name",
        },
        {
          label: "包裹号/包裹状态",
          slot: "packageNo",
        },
        {
          label: "包裹类型/包裹生成时间/打标来源",
          slot: "packageType",
        },
        {
          label: "包裹快递单号",
          prop: "shipping_num",
        },
        {
          label: "商家名称",
          prop: "supply_name",
        },
        {
          label: "城市/代采组/代采员",
          slot: "city_group_name",
          width: 200,
        },
        {
          label: "无数据理由",
          prop: "no_data_reason_trans",
        },
        {
          label: "状态",
          prop: "no_data_status_trans",
        },
        {
          label: "创建备注",
          prop: "create_remark",
        },
        {
          label: "移交代采图片",
          slot: "goodsImage",
        },
        {
          label: "包裹处理方案（代采核实）",
          prop: "buy_verify_trans",
          renderHeader(h) {
            return [h("div", "包裹处理方案"), h("div", "（代采核实）")];
          },
          width: 150,
        },
        {
          label: "代采核实备注",
          prop: "buy_verify_remark",
        },
        {
          label: "更正商家",
          prop: "corr_supply_name",
        },
        {
          label: "关联新包裹号",
          slot: "corrPackageNo",
        },
        {
          label: "仓库处理信息",
          prop: "storehouse_operation_trans",
        },
        {
          label: "仓库处理备注",
          slot: "storehouseRemark",
        },
        {
          label: "创建人/创建时间",
          slot: "created",
        },
        {
          label: "提交代采人/时间",
          slot: "submitBuy",
        },
        {
          label: "代采处理人/时间",
          slot: "buyHandle",
        },
        {
          label: "仓库处理人/时间",
          slot: "storehouseHandle",
        },
        {
          label: "操作",
          fixed: "right",
          slot: "actions",
        },
      ],
      logVisible: false,
      refreshLog: false,
      fetchMethodLog: postPageNoDataPackageRecord,
      initParams: { no_data_package_id: "" },
      columnsLog: [
        {
          label: "事件",
          prop: "operation_trans",
        },
        {
          label: "操作内容",
          prop: "content",
        },
        {
          label: "备注",
          prop: "remark",
        },
        {
          label: "操作人",
          prop: "admin_name",
        },
        {
          label: "操作时间",
          prop: "created_at",
        },
      ],
    };
  },
  created() {
    this.refresh = true;
    this.getOptions();
  },
  methods: {
    // 监听下拉选值改变
    handleSelectChange(item, searchParam) {
      // 当商家名称字段改变，将对应的id值赋给商家id字段
      if (item.field === "supply_name") {
        return { ...searchParam, supply_id: searchParam[item.field] };
      }
      return searchParam;
    },
    // 远程搜索商家
    fetchSupply(searchKey) {
      if (searchKey.length < 3) return;
      fetchSupplyBySearch({ supply_name: searchKey }).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          return;
        }
        this.options.supply = [{ label: "全部", value: "" }, ...res.data.data];
      });
    },
    // 获取下拉选择项
    getOptions() {
      getOptionsForList().then((resp) => {
        const {
          options_supply_city: city = [],
          options_pg_group: pgName = [], // 代采员
          options_pg_member: pgMember = [], // 代采组
        } = resp;

        this.options.city = city;
        this.options.pg_name = pgName;
        this.options.pg_member = pgMember;
        this.options.product_treatment = [
          {
            value: 1,
            label: "特价治理中-透传",
          },
          {
            value: 2,
            label: "特价治理不达标-下架",
          },
        ];
      });
      postListStockStorehouseConfig()
        .then((res) => {
          console.log("res", res);
          this.options.storeList = res;
          // this.initParams = { storehouse_id: res[0].key };
          // this.refresh = true;
        })
        .catch(this.$noop);
    },
    handleFetchSuccess(data) {
      this.list = data.list;
    },
    handleParamsChange(params) {
      this.searchParams = params;
    },
    handlePageChange(params) {
      this.searchPage = params;
    },
    // 导出
    handleExportExcelList() {
      const params = {
        ...this.searchPage,
        ...this.searchParams,
        is_excel: "1",
      };
      postListNoDataPackage(params)
        .then((res) => {
          if (res.file) {
            window.open(apiBaseURL + res.file);
          } else {
            this.$message.success("暂无包裹数据");
          }
        })
        .catch(this.$noop);
    },
    // 查看日志
    handleShowOperateLog(row) {
      this.logVisible = true;
      this.initParams = { no_data_package_id: row.id };
      this.refreshLog = true;
    },
    // 显示图片
    handleViewImages(images) {
      this.$viewerApi({
        images,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/NotDataPackageList/index.vue